import type { SlotData } from '../types';

const LINE_WIDTH = 45;
const LINE_ACTIVE_WIDTH = 65;
export const LINE_HEIGHT = 12;

export const SLOT_OPENER_AUTOMATION_ID = 'slot-opener-line';

export const getLineRect = (slot: SlotData, _isActive: boolean) => {
  const LINE_HEIGHT = 4;
  const LINE_MARGIN = 8;

  return {
    x: slot.layout.x + LINE_MARGIN,
    y: slot.layout.y + slot.layout.height / 2 - LINE_HEIGHT / 2,
    width: slot.layout.width - LINE_MARGIN * 2,
    height: LINE_HEIGHT,
  };
};

export const getLineRectV3 = (slot: SlotData, isActive: boolean) => {
  const width = isActive ? LINE_ACTIVE_WIDTH : LINE_WIDTH;
  const height = LINE_HEIGHT;

  return {
    x: slot.layout.x + slot.layout.width / 2 - width / 2,
    y: slot.layout.y + slot.layout.height / 2 - height / 2,
    width,
    height,

    middleX: slot.layout.x + slot.layout.width / 2,
    middleY: slot.layout.y + slot.layout.height / 2,
  };
};
